module.exports = __webpack_public_path__ + "static/media/gs.35681756.svg";